// import { updateMachObjectWithStore } from '@m2h/common/utils/machUtils';
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { isPathExist } from '@m2h/router/config';
import {
  getInitMachConf, _cleanupStaleRouteHandlers,
} from '@m2h/common/Mach/machproH5Base/base-h5';
import { publishMachPageVisibility } from '@m2h/common/Mach/pageVisibilityLifecycle';

// 特定回退页面
// 回退无上一页记录时，默认跳到首页，配置了的跳到指定页：
//  - 直接输入链接时，回退到上一页
// 正常交互逻辑中，需回退到指定页的
//  - 提单成功跳到订单详情页
const fixedDirections = {
  // from: 'to',
  '/mpweb/order_review': {
    path: '/mpweb/order_status_golden',
    urlParams: ['orderViewId'], // 带参数orderId
  },
};

// iframe打开的页面，继续跳转时保持在当前iframe打开，而不是默认的父级？
const openInIframePaths = [
  '/mpweb/market_history_coupon_list',
  // '-1',
  // -1
];

function goBack(steps: number = 1): void {
  if (typeof window !== 'undefined' && window.history) {
    // 确保 steps 是一个非负整数
    const safeSteps = Math.max(1, Math.floor(steps));
    window.history.go(-safeSteps);
  } else {
    console.warn('History API is not available.');
  }
}

export const setNavigate = (nav) => {
  window.spaRouterNavigate = nav;
};

/**
 * React Router 在 history.state.idx 中维护当前路由栈索引。
 * iframe 内的页面跳转由顶层 Router 接管，因此优先读取顶层窗口的路由栈。
 */
export const canNavigateBack = (): boolean => {
  try {
    const routerWindow = window.top || window;
    const routerHistoryIndex = routerWindow.history?.state?.idx;
    return typeof routerHistoryIndex !== 'number' || routerHistoryIndex > 0;
  } catch (error) {
    // 无法访问顶层窗口时退回当前窗口；未知索引保持返回入口可见。
    const routerHistoryIndex = window.history?.state?.idx;
    return typeof routerHistoryIndex !== 'number' || routerHistoryIndex > 0;
  }
};

export const routerNavigate = (path, options?: { replace?: boolean }) => {
  const { spaRouterNavigate: topSpaRouterNavigate } = window.top;

  if (topSpaRouterNavigate) {
    const pathExist = isPathExist(path);
    if (!pathExist) return;
    if (topSpaRouterNavigate !== window.spaRouterNavigate && openInIframePaths.includes(path)) {
      // 在iframe中执行时
      window.spaRouterNavigate?.(path);
    } else {
      // ----- mpweb适配origin -----
      // topSpaRouterNavigate(path);
      // ----- mpweb适配change -----
      // replace：把当前页从历史栈替换为目标页，供"提交成功后跳详情、返回时跳过本页"
      // 等场景复刻 Native 双重返回的净历史效果。
      topSpaRouterNavigate(path, options?.replace ? { replace: true } : undefined);
      // ----- mpweb适配       -----
    }
  } else {
    if (typeof path === 'number') return goBack(Math.abs(path));
    // console.error('Navigate function is not set');
    window.location.pathname = path;
  }
};

// useSpaRouter
export default function () {
  const navigate = useNavigate();
  // const location = useLocation();

  useEffect(() => {
    navigate && setNavigate(navigate);
    return () => {
      setNavigate(undefined);
    };
  }, [navigate]);

  useEffect(() => {
    // 因路由为懒加载的，此处执行分两种情况
    // 全新加载的页面(重新刷新，未加载过的路由)：最先执行此处
    // 已加载过的路由(路由回退/加载过的)：最后执行此处
    // ----- mpweb适配origin -----
    // window.Mach = {
    //   ...getInitMachConf(),
    //   ...window.Mach,
    // };
    // ----- mpweb适配change -----
    // 先清理已卸载路由注册的监听器再广播 appear：SPA 单路由活跃，注册于其他路由的
    // 监听器必然属于已卸载页面（僵尸监听），若不清理会在本路由 appear 时误触发
    // （order_refund 提交退款后被残留监听 navigateBack 弹回的根因）。
    _cleanupStaleRouteHandlers(
      window.location.pathname.replace(/\/+$/, '') || '/'
    );
    window.Mach = {
      ...getInitMachConf(),
      ...window.Mach,
    };
    // ----- mpweb适配       -----
    console.log('bundleName sparouter : useEffect', window.Mach.env);
    publishMachPageVisibility(window.Mach, !document.hidden);

    return () => {
      console.log('pageWillDisappear');
      publishMachPageVisibility(window.Mach, false);
    };
  }, []);
}
